import AuthPage from './AuthPage'
export { AuthPage }
export default AuthPage
